import { render } from "./LayoutFull.vue?vue&type=template&id=702c410a"
import script from "./LayoutFull.vue?vue&type=script&lang=js"
export * from "./LayoutFull.vue?vue&type=script&lang=js"
script.render = render

export default script